export default __webpack_public_path__ + "static/media/Group 2141.7c7ba7b0.svg";